import React, { forwardRef } from "react";

const Button = forwardRef(function Button(props, ref) {
    const {
        value = "",
        kbd = "",
        onClick = () => { },
        type = "",
        disabled = false,
        block = false,
        style = {},
        children,
        className = "ui-button",
        styled = false
    } = props;

    let _style = { ...style };
    let _class = className;

    if (styled) _class += " styled";

    if (type) _class += " " + type;
    if (disabled) _class += " disabled";
    if (block) _style.width = "100%";

    return (
        <button
            ref={ref}
            onClick={onClick}
            style={_style}
            className={_class}
            disabled={disabled}
        >
            <small>
                {children}
                {kbd && (
                    <small style={{ opacity: "0.6" }}>
                        <em>{kbd.label}</em>
                    </small>
                )}
            </small>
        </button>
    );
});

export default Button;
